module.exports = __webpack_public_path__ + "img/Virtual Estimate.svg";